import React, { useState, useEffect, useRef, FC } from "react";
import Content from "../../../layout/content/Content";
import {
  Badge,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  BlockDes,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  TooltipComponent,
  PaginationComponent,
} from "../../../components/Component";
import Swal from "sweetalert2";
import FormatDate from "../DateFormater";
import Export from "../../../components/export/Export";
import SequenceMaster from "./SequenceMaster";
import sequenceApis from "../../../api/master/sequence";
import { useSelector } from "react-redux";
import { Form, Select } from "antd";
import { Option } from "antd/es/mentions";


interface SelectOptions {
  label: string;
  value: string;
}

const SequenceList: FC = () => {
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);
  const [sm, setSm] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [detail, setDetail] = useState<any>({});
  const [popUpContent, setPopUpContent] = useState<JSX.Element | null>(null);
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);

  const fetchData = async () => {
    const { data, status, message } = await sequenceApis.fetchSequence();
    if (status) {
      setRowData(data);
      setOriginalData(data); // Store the original data
    } else {
      Swal.fire("Error", message, "error");
    }
  };
  const handleDelete = (_data: any) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes,In Active it!",
      allowOutsideClick: false,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-secondary",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteById(_data);
      }
    });
  };
  const deleteById = async (data: any) => {
    try {
      const { status, message } = await sequenceApis.updateSequenceStatusById(
        data.id
      );
      if (status) {
        fetchData();
        Swal.fire("Success", message, "success");
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [rowData, setRowData] = useState<any>([]);
  const [originalData, setOriginalData] = useState([]);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [sort, setSortState] = useState("");
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [statusFilter, setStatusFilter] = useState<string>("Active");
  const [siteFilter, setSiteFilter] = useState("");

  const viewChange = () => {
    if (window.innerWidth < 990) {
    } else {
      setSm(false);
    }
  };
  const loadDetail = (id: any) => {
    let index = rowData.findIndex((item: any) => item.id === id);
    setDetail(rowData[index]);
  };

  useEffect(() => {
    fetchData();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  useEffect(() => {
    if (onSearchText !== "") {
      const searchText = onSearchText.toLowerCase();

      const filteredObject = originalData.filter((item: any) => {
        return Object.values(item).some((value: any) => {
          // Convert value to string and then perform case-insensitive search
          return value && value.toString().toLowerCase().includes(searchText);
        });
      });
      setRowData(filteredObject); // Update state with filtered data
    } else {
      setRowData(originalData); // Reset to original data
    }
  }, [onSearchText, originalData]);

  const sortFunc = (params: any) => {
    let defaultData = rowData;
    if (params === "asc") {
      let sortedData = defaultData.sort((a: any, b: any) =>
        a.createdDate.localeCompare(b.createdDate)
      );
      setRowData([...sortedData]);
    } else if (params === "dsc") {
      let sortedData = defaultData.sort((a: any, b: any) =>
        b.createdDate.localeCompare(a.createdDate)
      );
      setRowData([...sortedData]);
    }
  };
  // function to toggle the search option

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = rowData.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber: any) => setCurrentPage(pageNumber);

  const onFilterChange = (e: any) => {
    setSearchText(e.target.value);
  };

  const handleModelPopUp = (id?: any, type?: string) => {
    const content = (
      <SequenceMaster
        formAction={type}
        id={id}
        activeModules={originalData
          ?.filter(
            (item: any) => item.status == "Active" && item?.level == "Org"
          )
          ?.map((item: any) => item.moduleId)}
        toggleModelPopUp={() => {
          setIsOpen(false);
          fetchData();
        }}
      />
    );
    setPopUpContent(content);
    setIsOpen(true);
  };


  useEffect(() => {
    if (currentUser) {
      let sitesOptions = currentUser?.siteAccessibility?.map((item: any) => ({
        label: item.siteName,
        value: item.siteID,
      }));
      setSitesOptions(sitesOptions);
    }
  }, [currentUser]);

  useEffect(() => {
    let filteredData = originalData;
    console.log(originalData)
    if (statusFilter) {
      filteredData = filteredData.filter(
        (item: any) => item.status == statusFilter
      );
    } 
    
    console.log(siteFilter,statusFilter,filteredData,onSearchText)
    if (siteFilter) {
      filteredData = filteredData.filter(
        (item: any) => item.siteId == siteFilter
      );
    }
    console.log(filteredData)

    if (onSearchText != "") {
      const searchText = onSearchText.toLowerCase();
      filteredData = filteredData.filter((item: any) =>
        Object.values(item).some(
          (value: any) =>
            value && value.toString().toLowerCase().includes(searchText)
        )
      );
    }

    if (!statusFilter && !siteFilter && !onSearchText) filteredData=filteredData.filter(
      (item: any) => item.status == "Active"
    );

    setRowData(filteredData);
    setCurrentPage(1);
  }, [onSearchText, originalData, statusFilter, siteFilter]);



  return (
    <React.Fragment>
      <Head title="sequence"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Sequence Settings
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have {rowData.length} module sequences in total.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${
                    sm ? "active" : ""
                  }`}
                  onClick={() => setSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div
                  className="toggle-expand-content"
                  style={{ display: sm ? "block" : "none" }}
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <Export data={rowData} />
                    </li>
                    {allowedActions?.add ? (
                      <li className="nk-block-tools-opt">
                        <Button
                          color="primary"
                          onClick={() => {
                            handleModelPopUp(null, "");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Add </span>
                        </Button>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <div
          className="card-inner position-relative card-tools-toggle"
          style={{ marginTop: "-5px" }}
        >
          <div className={`card-search search-wrap active`}>
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <form className="w-100 d-flex align-items-center">
                  <div className="d-flex align-items-center flex-wrap">
                    <div style={{ marginRight: 16, marginTop: 8 }}>
                      <Form.Item
                        name="site"
                        label="Site Filter"
                        className="mb-0 align-items-center"
                        style={{ width: 300, marginBottom: "5px" }}
                        initialValue=""
                      >
                        <Select
                          allowClear={true}
                          placeholder="Filter By Site"
                          options={sitesOptions}
                          onChange={setSiteFilter}
                        />
                      </Form.Item>
                    </div>
                    <div style={{ marginRight: 16, marginTop: 8 }}>
                      <Form.Item
                        name="status"
                        label="Status Filter"
                        className="mb-0 align-items-center"
                        style={{ width: 300, marginBottom: "5px" }}
                        initialValue="active"
                      >
                        <Select
                          allowClear={true}
                          placeholder="Filter By Status"
                          onChange={ setStatusFilter}
                        >
                          <Option value="Active">Active</Option>
                          <Option value="Inactive">Inactive</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>

                  <div className="search-container ms-auto">
                    <div
                      className="search-content"
                      style={{ whiteSpace: "nowrap", display: "flex" }}
                    >
                      <Button className="search-back btn-icon toggle-search active">
                        <Icon name="search"></Icon>
                      </Button>
                      <input
                        type="text"
                        className="border-transparent form-focus-none form-control"
                        placeholder="Search..."
                        value={onSearchText}
                        onChange={(e) => onFilterChange(e)}
                      />
                    </div>
                  </div>
                </form>

                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="a"
                    className="btn btn-trigger btn-icon dropdown-toggle"
                  >
                    <Icon name="filter"></Icon>
                  </DropdownToggle>
                  <DropdownMenu end className="dropdown-menu-xs">
                    <ul className="link-check">
                      <li>
                        <span>Show</span>
                      </li>
                      <li className={itemPerPage === 10 ? "active" : ""}>
                        <DropdownItem
                          tag="a"
                          href="#dropdownitem"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setItemPerPage(10);
                          }}
                        >
                          10
                        </DropdownItem>
                      </li>
                      <li className={itemPerPage === 15 ? "active" : ""}>
                        <DropdownItem
                          tag="a"
                          href="#dropdownitem"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setItemPerPage(15);
                          }}
                        >
                          15
                        </DropdownItem>
                      </li>
                    </ul>
                    <ul className="link-check">
                      <li>
                        <span>Order</span>
                      </li>
                      <li className={sort === "dsc" ? "active" : ""}>
                        <DropdownItem
                          tag="a"
                          href="#dropdownitem"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setSortState("dsc");
                            sortFunc("dsc");
                          }}
                        >
                          DESC
                        </DropdownItem>
                      </li>
                      <li className={sort === "asc" ? "active" : ""}>
                        <DropdownItem
                          tag="a"
                          href="#dropdownitem"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setSortState("asc");
                            sortFunc("asc");
                          }}
                        >
                          ASC
                        </DropdownItem>
                      </li>
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </div>
          </div>
        </div>

        <Block>
          <DataTable
            className="card-stretch"
            bodyClassName={undefined}
            title={undefined}
          >
            <DataTableBody compact className={undefined} bodyclass={undefined}>
              <DataTableHead>
                {/* <DataTableRow className={undefined} size={undefined}>
                  <span className="sub-text">#</span>
                </DataTableRow> */}
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">MODULE</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">PREFIX</span>
                </DataTableRow>
                <DataTableRow size="sm" className={undefined}>
                  <span className="sub-text">SEQUENCE NO</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">CREATED DATE</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">END DATE</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">SET SEQUENCE FOR</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">SITE</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}>
                  <span className="sub-text">STATUS</span>
                </DataTableRow>
                <DataTableRow size="md" className={undefined}></DataTableRow>
              </DataTableHead>

              {currentItems.length > 0
                ? currentItems.map((item: any, index: number) => {
                    return (
                      <DataTableItem
                        key={item.id}
                        className={undefined}
                        style={{ color: "black" }}
                      >
                        {/* <DataTableRow size="md" className={undefined}>
                          <span>{index + 1}</span>
                        </DataTableRow> */}
                        <DataTableRow size="md" className={undefined}>
                          <span>{item.moduleName}</span>
                        </DataTableRow>
                        <DataTableRow size="md" className={undefined}>
                          <span>{item.prefix}</span>
                        </DataTableRow>
                        <DataTableRow size="md" className={undefined}>
                          <span>{item.sequenceNo}</span>
                        </DataTableRow>

                        <DataTableRow size="md" className={undefined}>
                          <span>{FormatDate(item.createdDate)}</span>
                        </DataTableRow>
                        <DataTableRow size="sm" className={undefined}>
                          <span>{FormatDate(item.endDate)}</span>
                        </DataTableRow>
                        <DataTableRow size="sm" className={undefined}>
                          <span>
                            {!item?.level
                              ? "N/A"
                              : item?.level === "Org"
                              ? "Organisation"
                              : "Site"}
                          </span>
                        </DataTableRow>

                        <DataTableRow size="sm" className={undefined}>
                          <span>{item.siteName || "N/A"}</span>
                        </DataTableRow>
                        <DataTableRow size="md" className={undefined}>
                          <span
                            className={`tb-status text-${
                              item.status === "Active" ? "success" : "danger"
                            }`}
                          >
                            {item.status === "Active" ? "Active" : "In Active"}
                          </span>
                        </DataTableRow>
                        <DataTableRow size="md" className={undefined}>
                          <ul className="nk-tb-actions">
                            {item?.status === "Active" &&
                            allowedActions?.edit ? (
                              <li
                                className="nk-tb-action-hidden"
                                onClick={() =>
                                  handleModelPopUp(item.id, "edit")
                                }
                              >
                                <TooltipComponent
                                  tag="a"
                                  containerClassName="btn btn-trigger btn-icon"
                                  id={"edit" + item.id}
                                  icon="edit-alt-fill"
                                  direction="top"
                                  text="Edit"
                                  iconClass={undefined}
                                />
                              </li>
                            ) : (
                              <></>
                            )}
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  tag="a"
                                  className="dropdown-toggle btn btn-icon btn-trigger"
                                >
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <ul className="link-list-opt no-bdr">
                                    {item?.status === "Active" &&
                                    allowedActions?.edit ? (
                                      <li onClick={() => {}}>
                                        <DropdownItem
                                          tag="a"
                                          href="#edit"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            handleModelPopUp(item.id, "edit");
                                          }}
                                        >
                                          <Icon name="edit"></Icon>
                                          <span>Edit</span>
                                        </DropdownItem>
                                      </li>
                                    ) : (
                                      <></>
                                    )}
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#edit"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          loadDetail(item.id);
                                          setViewModal(true);
                                        }}
                                      >
                                        <Icon name="focus"></Icon>
                                        <span>View Details</span>
                                      </DropdownItem>
                                    </li>
                                    {item?.status === "Active" &&
                                    allowedActions?.edit ? (
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#edit"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            handleDelete(item);
                                          }}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>In Active</span>
                                        </DropdownItem>
                                      </li>
                                    ) : (
                                      <></>
                                    )}
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={rowData.length}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
      </Content>
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setIsOpen(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>{popUpContent}</ModalBody>
      </Modal>
      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(false)}
        className="modal-dialog-centered"
        size="lg"
        backdrop="static"
      >
        <ModalBody>
          <a
            href="#cancel"
            onClick={(ev) => {
              ev.preventDefault();
              setViewModal(false);
            }}
            className="close"
          >
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="nk-modal-head">
            <h4 className="nk-modal-title title">
              {detail?.moduleName} Sequence Details
            </h4>
          </div>
          <div className="nk-tnx-details mt-sm-3">
            <Row className="gy-3">
              <Col lg={6}>
                <span className="sub-text">PREFIX</span>
                <span className="caption-text">{detail?.prefix}</span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">SEQUENCE NO</span>
                <span className="caption-text">{detail?.sequenceNo}</span>
              </Col>
              {detail?.stateName ? (
                <Col lg={6}>
                  <span className="sub-text">State Name</span>
                  <span className="caption-text">{detail?.stateName}</span>
                </Col>
              ) : (
                <></>
              )}
              <Col lg={6}>
                <span className="sub-text">Created Date</span>
                <span className="caption-text">
                  {" "}
                  {FormatDate(detail?.createdDate)}
                </span>
              </Col>
              <Col lg={6}>
                <span className="sub-text">End Date</span>
                <span className="caption-text"> {FormatDate(detail?.end)}</span>
              </Col>

              <Col lg={6}>
                <span className="sub-text">Status</span>
                <Badge
                  color={detail?.status === "Active" ? "success" : "danger"}
                  size="md"
                >
                  {detail?.status === "Active" ? "Active" : "Inactive"}
                </Badge>
              </Col>
              <Col lg={6}>
                <span className="sub-text">Set Sequence For</span>
                <span className="caption-text">
                  {!detail?.level
                    ? "N/A"
                    : detail?.level === "Org"
                    ? "Organization"
                    : "Site"}
                </span>
              </Col>
              {detail?.level == "Site" && (
                <Col lg={6}>
                  <span className="sub-text">Site</span>
                  <span className="caption-text">{detail?.siteName}</span>
                </Col>
              )}
            </Row>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default SequenceList;
